<template>
  <b-overlay
    class="lp-container"
    :show="loading"
    variant="transparent"
    rounded="sm"
  >
    <div class="lp-content">
      <div
        v-if="step < 6"
        class="logo p-1"
      >
        <img
          src="@/assets/images/logo/logo.png"
          alt="boho logo"
          width="100"
        >
      </div>
      <div
        v-if="step < 6"
        class="lp-progress-container p-1"
      >
        <div class="lp-progress-bar">
          <div
            class="lp-progress-step"
            :class="{active: step > 0}"
          >
            1
          </div>
          <div
            class="lp-progress-line"
            :class="{active: step > 1, 'half-active': step === 1}"
          />
          <div
            class="lp-progress-step"
            :class="{active: step > 1}"
          >
            2
          </div>
          <div
            class="lp-progress-line"
            :class="{active: step > 2, 'half-active': step === 2}"
          />
          <div
            class="lp-progress-step"
            :class="{active: step > 2}"
          >
            3
          </div>
          <div
            class="lp-progress-line"
            :class="{active: step > 3, 'half-active': step === 3}"
          />
          <div
            class="lp-progress-step"
            :class="{active: step > 3}"
          >
            4
          </div>
          <div
            class="lp-progress-line"
            :class="{active: step > 4, 'half-active': step === 4}"
          />
          <div
            class="lp-progress-step"
            :class="{active: step > 4}"
          >
            5
          </div>
        </div>
      </div>
      <transition name="slide">
        <router-view
          :key="$route.fullPath"
          :age="age"
          :loading="loading"
          :products="products"
          :selected-product="selectedProduct"
          :step="step"
          :username="username"
          @lpUserAction="lpUserAction($event, false)"
          @nextStep="nextStep"
          @setAge="age = $event"
          @setLoading="loading = $event"
          @setUsername="username = $event"
          @updateOptionConnection="optionConnection = $event"
          @updateSelectedProduct="updateSelectedProduct($event)"
        />
      </transition>
    </div>
  </b-overlay>
</template>

<script>
import { localeChanged, localize } from 'vee-validate'
import { BOverlay } from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { throwDefaultError } from '@/helpers/helpers'

export default {
  name: 'Lp3',
  components: {
    BOverlay,
  },
  data() {
    return {
      age: 18,
      loading: false,
      lpProducts: [
        {
          id: 'com.arasana.app.10DKl',
          name: '',
        },
        {
          id: 'com.arasana.app.25DKl',
          name: this.$t('lps.product.MOST POPULAR'),
          discount: 40,
          popular: true,
        },
        {
          id: 'com.arasana.app.50DKl',
          name: this.$t('lps.product.Best Value'),
        },
      ],
      optionConnection: null,
      products: [],
      purchaseSource: 'lp3',
      selectedProduct: null,
      step: 1,
      username: '',
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
  },
  watch: {
    optionConnection(value, oldValue) {
      if (value && oldValue !== value) {
        this.nextStep()
      }
    },
  },
  created() {
    this.step = this.$route.meta?.step || 1

    this.checkRoute()

    localize(this.$i18n.locale)
    localeChanged()

    this.getProducts()

    this.lpUserAction()

    localStorage.setItem('try_route_name', 'lp3')

    if (this.user) {
      this.lpUserAction('current-user-detected', false)
      this.$router.push('/')
    }
  },
  methods: {
    checkRoute() {
      if (this.step > 1 && !this.optionConnection) {
        this.nextStep(1)
      } else if (this.step > 2 && !this.age) {
        this.nextStep(2)
      } else if (this.step > 3 && !this.username) {
        this.nextStep(3)
      } else if (this.step > 4 && !this.user) {
        this.nextStep(4)
      } else if (this.step > 6 && !this.selectedProduct) {
        this.nextStep(6)
      }
    },
    getProducts() {
      useJwt.getLandingProducts()
        .then(response => {
          const products = response.data.body || []

          this.products = this.lpProducts.map(p => {
            const product = {
              ...p,
              product: products.find(p2 => p2.productId === p.id),
            }

            if (p.popular) {
              this.selectedProduct = {
                ...product,
              }
            }

            return product
          }).filter(p2 => !!p2.product)
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    lpUserAction(action = 'new-user', showLoading = true, subData = null) {
      if (showLoading) {
        this.loading = true
      }

      // eslint-disable-next-line no-underscore-dangle
      const _data = {}

      if (showLoading && this.$route.query) {
        Object.assign(_data, { query: this.$route.query })
      }

      if (subData) {
        Object.assign(_data, { data: subData })
      }

      const data = {
        flow: 'lp-3',
        action,
        data: JSON.stringify(_data),
        deviceId: this.$store.getters['app/deviceId'],
      }

      useJwt.lpUserAction(data)
        .then(response => {
          localStorage.setItem('tempLoginToken', response.data.body.loginToken)
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          if (showLoading) {
            this.loading = false
          }
        })
    },
    nextStep(step = null) {
      this.step = step ?? this.step + 1
      this.$router.push({
        name: `lp3.step-${this.step}`,
      })
      if (this.step < 4 || this.step === 5) {
        this.lpUserAction(`step-${this.step}`, false)
      } else if (this.step === 4) {
        this.lpUserAction('auth', false)
      } else if (this.step === 6) {
        this.lpUserAction('choose-product', false)
      } else if (this.step === 7) {
        this.lpUserAction('buy-product', false)
      }
    },
    updateSelectedProduct(event) {
      this.lpUserAction('choose-product', false, { product: event.id })

      this.selectedProduct = event
    },
  },
}
</script>

<style scoped lang="scss">
.lp-content {
  .logo {
    text-align: center;
    -webkit-text-fill-color: transparent;
  }
  .lp-progress-container {
    width: 100%;
    margin-bottom: 4px;

    .lp-progress-bar {
      display: flex;
      align-items: center;
      position: relative;

      .lp-progress-step {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: rgba(172, 51, 244, 0.4);
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        color: white !important;
        font-size: 16px;
        z-index: 2;

        &.active {
          background-color: rgba(172, 51, 244, 1);
        }
      }
      .lp-progress-line {
        flex-grow: 1;
        height: 5px;
        background-color: rgba(172, 51, 244, 0.4);
        margin: 0 -1px;
        position: relative;

        &.half-active::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 10px;
          height: 100%;
          background-color: rgba(172, 51, 244, 1);
          border-radius: 14px;
        }
        &.active {
          background-color: rgba(172, 51, 244, 1);
        }
      }
    }
  }
}
</style>

<style lang="scss">
.lp-content {
  .step-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
  }
  .lp-step {
    display: flex;
    justify-content: center;
    position: relative;
    height: calc(100vh - 148px);
    flex-direction: column;

    &.bg-people-blur {
      background: url('~@/assets/images/lps/people2-blur.png');
      background-position: left top;
      background-repeat: no-repeat;
      background-size: cover;
      padding-right: 4px !important;
    }
    &.bg-people {
      background: url('~@/assets/images/lps/people2.png');
      background-position: left top;
      background-repeat: no-repeat;
      background-size: cover;
      margin: 6px !important;
    }

    .lp-popup {
      background-color: #fff;
      border-radius: 16px;
      padding: 14px;
      width: 96%;
      position: absolute;
      bottom: 8px !important;
      max-height: calc(100% - 16px);
      left: 2%;
      overflow: auto !important;
      -webkit-box-shadow: 0 0 5px 0 rgba(0,0,0,0.5);
      -moz-box-shadow: 0 0 5px 0 rgba(0,0,0,0.5);
      box-shadow: 0 0 5px 0 rgba(0,0,0,0.5);
    }

    /* Standart syntax */
    .placeholder-black::placeholder {
      color: #071034 !important;
    }

    /* WebKit, Edge */
    .placeholder-black::-webkit-input-placeholder {
      color: #071034 !important;
    }

    /* Firefox 4-18 */
    .placeholder-black:-moz-placeholder {
      color: #071034 !important;
      opacity: 1 !important;
    }

    /* Firefox 19+ */
    .placeholder-black::-moz-placeholder {
      color: #071034 !important;
      opacity: 1 !important;
    }

    /* IE 10-11 */
    .placeholder-black:-ms-input-placeholder {
      color: #071034 !important;
    }

    /* Edge */
    .placeholder-black::-ms-input-placeholder {
      color: #071034 !important;
    }

    input:not(.vue-pincode-input) {
      background-color: #e3e1e1 !important;
      padding: 24px 12px;
      border-radius: 18px;
    }
  }
}
</style>
